import {Group, Switch, Text} from "@mantine/core";
import {useLocalStorage} from "@mantine/hooks";
import {LocalStorageKeys} from "../../../../types";
import classes from "./SettingSelectField.module.css";

export function ExperimentalModeToggle() {
    const [experimentalMode, setExperimentalMode] = useLocalStorage({
        key: LocalStorageKeys.ExperimentalMode,
        defaultValue: false,
    });

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>
                Experimental Mode
            </Text>
            <Switch
                className={classes.innerItem}
                checked={experimentalMode}
                onChange={(event) =>
                    setExperimentalMode(event.currentTarget.checked)
                }
            />
        </Group>
    );
}
